import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'
import { buildBackendLoginUrl, currentReturnPath, fetchAuthSession, logoutAuthSession, preferredUserLabel } from '@aide/auth-client'
import type { AuthSessionData } from '@aide/platform-types'

interface AuthContextType {
  authenticated: boolean
  user: string | null
  profile: AuthSessionData | null
  loading: boolean
  login: (nextPath?: string, loginHint?: string, tenant?: string) => Promise<void>
  signup: (nextPath?: string, loginHint?: string) => Promise<void>
  logout: () => Promise<void>
}

const AuthContext = createContext<AuthContextType | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [profile, setProfile] = useState<AuthSessionData | null>(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    void fetchAuthSession().then(value=>{if(value?.authenticated)document.documentElement.dataset.workspaceContext=JSON.stringify([value.tenant_id||null,value.id]);setProfile(value)}).catch(() => setProfile(null)).finally(() => setLoading(false))
  }, [])
  const login = useCallback(async (nextPath?: string, loginHint?: string, tenant?: string) => {
    window.location.assign(buildBackendLoginUrl('folio', nextPath || '/', window.location.origin, '/api', undefined, loginHint, tenant))
  }, [])
  const signup = useCallback(async (nextPath?: string, loginHint?: string) => {
    window.location.assign(buildBackendLoginUrl('folio', nextPath || '/', window.location.origin, '/api', 'signup', loginHint))
  }, [])
  const logout = useCallback(async () => {
    await logoutAuthSession();setProfile(null)
  }, [])
  return <AuthContext.Provider value={{ authenticated: Boolean(profile?.authenticated), user: preferredUserLabel(profile), profile, loading, login, signup, logout }}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within AuthProvider')
  return context
}
